import { PawPrint } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

/**
 * Story 13A: "Witaj w społeczności" - wariant z opisami pod każdym krokiem
 */
export const InstagramStoryShare13A = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#1a3a2a",
      }}
    >
      <img src={bgImage} alt="" draggable={false} data-export-bg="true" loading="eager" decoding="sync"
        style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover", zIndex: 0 }} />
      <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: "8px", background: "linear-gradient(90deg, #4E8A6E 0%, #6BAF8D 50%, #4E8A6E 100%)", zIndex: 2 }} />

      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "160px 72px",
          position: "relative",
          zIndex: 1,
        }}
      >
        {/* Welcome */}
        <p style={{ fontSize: "40px", fontWeight: 600, color: "#4A7A5E", margin: "0 0 8px", textAlign: "center", lineHeight: 1.4 }}>
          Skoro tu jesteś, to znaczy że
        </p>
        <h1 style={{ fontSize: "64px", fontWeight: 800, color: "#2D5A3D", margin: "0 0 8px", textAlign: "center", lineHeight: 1.2 }}>
          masz dobre serduszko 💚
        </h1>
        <p style={{ fontSize: "36px", fontWeight: 600, color: "#5A8A70", margin: "0 0 36px", textAlign: "center" }}>
          i kochasz zwierzaki 🐾
        </p>

        <div style={{ width: "100px", height: "6px", background: "#4E8A6E", borderRadius: "3px", marginBottom: "36px" }} />

        <p style={{ fontSize: "44px", fontWeight: 800, color: "#2D5A3D", margin: "0 0 32px", textAlign: "center" }}>
          Co robimy? 👇
        </p>

        {/* Steps */}
        <div style={{ display: "flex", flexDirection: "column", gap: "18px", width: "100%", maxWidth: "920px" }}>
          {/* Step 1 */}
          <div style={{ background: "rgba(255,255,255,0.95)", borderRadius: "24px", padding: "28px 36px", boxShadow: "0 4px 16px rgba(0,0,0,0.06)" }}>
            <div style={{ display: "flex", gap: "16px", alignItems: "center", marginBottom: "10px" }}>
              <span style={{ fontSize: "36px" }}>🔍</span>
              <p style={{ fontSize: "32px", fontWeight: 800, color: "#2D5A3D", margin: 0 }}>Sprawdź potrzeby schronisk</p>
            </div>
            <p style={{ fontSize: "28px", fontWeight: 600, color: "#5A8A70", margin: 0, paddingLeft: "52px", lineHeight: 1.4 }}>
              Wejdź na stronę, znajdź schronisko w okolicy i zobacz czego teraz potrzebuje - karma, koce, spacery z psami
            </p>
          </div>

          {/* Step 2 */}
          <div style={{ background: "rgba(255,255,255,0.95)", borderRadius: "24px", padding: "28px 36px", boxShadow: "0 4px 16px rgba(0,0,0,0.06)" }}>
            <div style={{ display: "flex", gap: "16px", alignItems: "center", marginBottom: "10px" }}>
              <span style={{ fontSize: "36px" }}>➕</span>
              <p style={{ fontSize: "32px", fontWeight: 800, color: "#2D5A3D", margin: 0 }}>Dodaj brakujące schroniska</p>
            </div>
            <p style={{ fontSize: "28px", fontWeight: 600, color: "#5A8A70", margin: 0, paddingLeft: "52px", lineHeight: 1.4 }}>
              Znasz schronisko, którego nie ma na mapie? Dodaj je lub prześlij im link - same mogą uzupełnić swoje potrzeby
            </p>
          </div>

          {/* Step 3 - highlighted */}
          <div style={{ background: "rgba(255,255,255,0.95)", borderRadius: "24px", padding: "28px 36px", boxShadow: "0 8px 32px rgba(0,0,0,0.1)", border: "3px solid #4E8A6E" }}>
            <div style={{ display: "flex", gap: "16px", alignItems: "center", marginBottom: "10px" }}>
              <span style={{ fontSize: "36px" }}>📢</span>
              <p style={{ fontSize: "32px", fontWeight: 800, color: "#2D5A3D", margin: 0 }}>Zostań z nami</p>
            </div>
            <p style={{ fontSize: "28px", fontWeight: 700, color: "#2D5A3D", margin: 0, paddingLeft: "52px", lineHeight: 1.4 }}>
              Obserwuj to konto - będę udostępniać zweryfikowane, pilne potrzeby schronisk, żebyś mógł/mogła pomóc od razu 🐾
            </p>
          </div>
        </div>
      </div>

      <div style={{ padding: "0 80px 100px", display: "flex", justifyContent: "center", position: "relative", zIndex: 1 }}>
        <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
          <div style={{ background: "#4E8A6E", borderRadius: "14px", width: "52px", height: "52px", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <PawPrint style={{ width: "28px", height: "28px", color: "#FFFFFF" }} />
          </div>
          <span style={{ fontSize: "28px", fontWeight: 700, color: "#2D5A3D" }}>gdzieschronisko.pl</span>
        </div>
      </div>
    </div>
  );
};
